import React from 'react'
import ReactDOM from 'react-dom'
import firebase from 'firebase/app'
import { Provider } from 'react-redux'
import { MuiThemeProvider } from '@material-ui/core/styles'
import {
  Route,
  Switch,
  Redirect,
  BrowserRouter as Router,
} from 'react-router-dom'

import 'firebase/storage'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/firebase-auth'

import App from './App'
import PageAdmin from './containers/PageAdmin'
import PageLogin from './containers/PageLogin'
import ScrollTop from './components/ScrollTop'

import store from './store'
import { FIREBASE_CONFIG } from './constant'
import * as serviceWorker from './serviceWorker'

import theme from './theme'


firebase.initializeApp(FIREBASE_CONFIG)
// eslint-disable-next-line
firebase.firestore().enablePersistence().catch(console.error)

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <ScrollTop>
        <MuiThemeProvider theme={theme}>
          <App>
            <Switch>
              <Route exact path="/login" component={PageLogin} />
              <Route path="/" component={PageAdmin} />

              <Redirect to="/" />
            </Switch>
          </App>
        </MuiThemeProvider>
      </ScrollTop>
    </Router>
  </Provider>,
  document.getElementById('root'),
)


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
